import { decode } from './utils/decode';

export const customCluster = (color: string) => {
  const decodedSvg =
    decode(`<svg fill="${color}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
    <circle cx="120" cy="120" r="70" />
</svg>`);

  return `data:image/svg+xml;base64,${decodedSvg}`;
};
